export default __webpack_public_path__ + "static/media/a10.431bbf41.png";